import React from 'react';
import {connect } from 'react-redux';
import { showAlertModal, setDate, setCamera, setEventTags, setStartTime, setEndTime, getPlaybackEvents, filterEventsByTags, setScrollerObj, setSelectedEvent } from '../../actions';
import loading_icon from '../../loading_icon.jpeg';

const FilterContainer = props => {
  const handleGetEvents = async () => {
    if (props.date === '' || !props.camera || props.camera === '0') {
      props.showAlertModal(['WARNING', 'Date and camera fields are required. Please review.'])
      return
    }

    if (!props.searchFilters || Object.keys(props.searchFilters).length === 0 || props.date !== props.searchFilters.date || props.camera !== props.searchFilters.camera) {
      // if either date/camera is changed, call the api and start from the first 4 hours of the day
      const startTime = '000000'
      const endTime = '040000'
      props.setStartTime(startTime)
      props.setEndTime(endTime)
      props.setScrollerObj('')
      props.setSelectedEvent({})
      await props.getPlaybackEvents(props.token, props.date, props.cameras, props.camera, props.eventTags, startTime, endTime, props.events, true)

    } else {
      // else, just filter the events we have by tags
      props.filterEventsByTags(props.events, props.eventTags, props.searchFilters)
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.filterGroup}>
        <span>Date:</span>
        <input type="date" value={props.date} onChange={(e) => {props.setDate(e.target.value)}} style={styles.inputs} />
      </div>

      <div style={styles.filterGroup}>
        <span>Camera:</span>
        <select style={styles.cameraSelect} value={props.camera} onChange={e => props.setCamera(e.target.value)}>
          <option value={0}>Select Camera</option>
          {props.cameras.filter(c => c.bProfile === 1).map( c => (
            <option key={c.bID} value={c.bID}>{c.label}</option>
          ))}
        </select>
      </div>

      <div style={styles.tags}>
        <div>Tags:</div>
        <div style={styles.filterGroup}>
          <input id="person" type="checkbox" checked={props.eventTags && props.eventTags.includes('person')} onChange={e => props.setEventTags(props.eventTags, 'person', e.target.checked)} />
          <label htmlFor="person" style={{...styles.inputs, color: 'lightseagreen'}}>Person</label>
        </div>
        <div style={styles.filterGroup}>
          <input id="vehicle" type="checkbox" checked={props.eventTags && props.eventTags.includes('vehicle')} onChange={e => props.setEventTags(props.eventTags, 'vehicle', e.target.checked)} />
          <label htmlFor="vehicle" style={{...styles.inputs, color: 'dodgerblue'}}>Vehicle</label>
        </div>
      </div>

      <div>
        <button className="cursor-pointer" onClick={() => handleGetEvents()}
          style={{...styles.searchButton, cursor: props.eventsLoading ? 'wait' : 'pointer'}} >
          Find
          {props.eventsLoading && <img src={loading_icon} alt="loading" height={16} width='auto' />}
        </button>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { token } = state.auth
  const { cameras } = state.data
  const { date, camera, eventTags, startTime, endTime, eventsLoading, searchFilters, events } = state.playback

  return {
    token,
    cameras,
    date,
    camera,
    eventTags,
    startTime,
    endTime,
    eventsLoading,
    searchFilters,
    events,
  }
}

export default connect(mapStateToProps, {
  showAlertModal,
  setDate,
  setCamera,
  setEventTags,
  setStartTime,
  setEndTime,
  getPlaybackEvents,
  filterEventsByTags,
  setScrollerObj,
  setSelectedEvent,
})(FilterContainer)

const styles = {
  container: {
    height: '5vh',
    display: 'flex',
    alignItems: 'center',
    gap: '2vmin',
    marginBottom: '1vmin',
    padding: '1vmin .5vmin',
    border: '1px solid gray',
    overflow: 'auto hidden',
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
  inputs: {
    cursor: 'pointer',
  },
  cameraSelect: {
    width: '20vmin',
    cursor: 'pointer',
  },
  tags: {
    display: 'flex',
    alignItems: 'center',
  },
  searchButton: {
    display: 'flex',
    gap: '.5vmin',
    borderRadius: 5,
    padding: '.3vmin 2vmin',
  },
}